import ReactGA from 'react-ga4'

export const trackingId = 'G-ME7K3JP1NG'
ReactGA.initialize([{ trackingId }])
export const pageView = (path) => {
  return ReactGA.send({
    hitType: 'pageview',
    page: path,
    page_url: window.location.href,
  })
}

// custom event with label being an optional parameter
export const customEvent = (category = '', action = '', label = '') => {
  return ReactGA.event({
    category,
    action,
    label,
  })
}

// eslint-disable-next-line consistent-return
const handleEvent = (event) => {
  let { target } = event
  if (!target) {
    return
  }
  while (
    target &&
    target.hasAttribute('g-action') === false &&
    target.tagName !== 'BODY'
  ) {
    target = target.parentNode
  }
  if (target && target.hasAttribute('g-action')) {
    const category = target.getAttribute('g-category') || undefined // 分類：網站頁面
    const action = target.getAttribute('g-action') || undefined // 事件：功能名稱
    customEvent(category, action)
  }
}

export const start = () => {
  pageView('felo')
  // body 外無 hasAttribute 方法，避免錯誤
  const body = document.querySelector('body')
  // eslint-disable-next-line
  body?.addEventListener('click', handleEvent, false)
}

export const reactGA = ReactGA
